import React, { Fragment } from 'react';
export const text = {
  BREW_KEG: 'brew keg',
  BREW_TANK: 'brew tank',
  BRITE_TANK: 'brite tank',
  UNI_TANK: 'uni tank'
};

const TankTypeText = ({ type, capitalise }) => {
  const measure = text[type] || type;
  return <Fragment>{capitalise ? `${measure.charAt(0).toUpperCase()}${measure.slice(1)}` : measure}</Fragment>;
};

export default TankTypeText;



// WEBPACK FOOTER //
// ./src/components/tankTypeText/tankTypeText.jsx